import { render, staticRenderFns } from "./EventInspector.vue?vue&type=template&id=15b2d97f&scoped=true&"
import script from "./EventInspector.vue?vue&type=script&lang=js&"
export * from "./EventInspector.vue?vue&type=script&lang=js&"
import style0 from "./EventInspector.vue?vue&type=style&index=0&id=15b2d97f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b2d97f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b2d97f')) {
      api.createRecord('15b2d97f', component.options)
    } else {
      api.reload('15b2d97f', component.options)
    }
    module.hot.accept("./EventInspector.vue?vue&type=template&id=15b2d97f&scoped=true&", function () {
      api.rerender('15b2d97f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/events/EventInspector.vue"
export default component.exports